import { useCallback } from 'react';

import { LoaderWrapper } from '@components/widgets';
import classNames from 'classnames';
import './profilePlanItem.scss';

interface Props {
    title: string;
    isFirstOrder?: boolean;
    isCurrent?: boolean;
    showCurrentTag?: boolean;
    hideDescription?: boolean;
    subTitle: string;
    description?: string;
    price: string | number;
    onClick?: () => void;
    isLoading?: boolean;
    isAnnual?: boolean;
}

const ProfilePlanItem = ({
    isAnnual = false,
    isLoading = false,
    isFirstOrder = false,
    title,
    isCurrent,
    showCurrentTag = true,
    hideDescription = false,
    subTitle,
    description,
    price,
    onClick
}: Props) => {
    const handleButton = useCallback(() => onClick?.(), [onClick]);

    return (
        <div className='profile-plan-item'>
            {isLoading && <LoaderWrapper />}

            <div className="ppi-head">
                <h2>{title}</h2>
                {isCurrent && showCurrentTag && (
                    <div className="ppi-curr">
                        <p>current plan</p>
                    </div>
                )}
            </div>
            <p className='ppi-sub'>{subTitle}</p>

            {!hideDescription && <div className='ppi-desc' dangerouslySetInnerHTML={{ __html: description }} />}

            <div className="ppi-separator" />

            <h5>${price} <span>/ {isAnnual ? 'year' : 'month'}</span></h5>

            {onClick && (
                <button type='button' className={classNames('ppi-button', { isCurrent })} onClick={handleButton}>
                    {isCurrent
                        ? 'Renew Plan'
                        : isFirstOrder
                            ? 'Choose Plan'
                            : 'Upgrade Plan'}
                </button>
            )}
        </div>
    );
};

export default ProfilePlanItem;
